module.exports = __webpack_public_path__ + "static/media/file-certificate.cfa3914a.svg";